function CloseOverlays() {
  theme?.Overlay?.DeActivateOverlay?.()
}

document.addEventListener('shopify:block:select', (evnt) => {
  console.log(evnt)
  CloseOverlays()
});
document.addEventListener('shopify:block:deselect',(evnt) => {
  console.log(evnt)
  CloseOverlays()
});
document.addEventListener('shopify:section:load', (evnt) => {
  console.log(evnt)
  CloseOverlays();
});

document.addEventListener('shopify:section:reorder', () => {
  console.log(evnt)
  CloseOverlays()
});

document.addEventListener('shopify:section:select', (evnt) => {
  console.log(evnt)
  CloseOverlays()
});

document.addEventListener('shopify:section:deselect', (evnt) => {
  console.log(evnt)
  CloseOverlays()
});

document.addEventListener('shopify:inspector:activate', (evnt) => {
  console.log(evnt)
  CloseOverlays()
});

document.addEventListener('shopify:inspector:deactivate', (evnt) => {
  console.log(evnt)
  CloseOverlays()
});
